import React from 'react';
import Button from 'components/common/Button';

export default () => {
  return <Button btnStyle="outline" color="secondary" className="text-uppercase">Book a room</Button>;
};


// WEBPACK FOOTER //
// ./src/components/common/BookButton.js